export const GET_APPOINTMENTS_STATED = "GET_APPOINTMENTS_STATED";
export const GET_APPOINTMENTS = "GET_APPOINTMENTS";
export const GET_APPOINTMENTS_ENDED = "GET_APPOINTMENTS_ENDED";
export const ADD_APPOINTMENT_STATED = "ADD_APPOINTMENT_STARTED";
export const ADD_APPOINTMENT = "ADD_APPOINTMENT";
export const ADD_APPOINTMENT_ENDED = "ADD_APPOINTMENT_ENDED";
export const EDIT_APPOINTMENT_STATED = "EDIT_APPOINTMENT_STATED";
export const EDIT_APPOINTMENT = "EDIT_APPOINTMENT";
export const EDIT_APPOINTMENT_ENDED = "EDIT_APPOINTMENT_ENDED";
export const GET_APPOINTMENT = "GET_APPOINTMENT";
export const GET_APPOINTMENT_STATED = "GET_APPOINTMENT_STATED";
export const GET_APPOINTMENT_ENDED = "GET_APPOINTMENT_ENDED";
export const RESET_APPOINTMENT = "RESET_APPOINTMENT";
export const ERROR_APPOINTMENT = "ERROR_APPOINTMENT";
export const GET_ALL_APPOINTMENTS_STATED = "GET_ALL_APPOINTMENTS_STATED";
export const GET_ALL_APPOINTMENTS = "GET_ALL_APPOINTMENTS";
export const GET_ALL_APPOINTMENTS_ENDED = "GET_ALL_APPOINTMENTS_ENDED";
